import { useTranslations } from '@vocab/react';
import {
  Box,
  Stack,
  IconArrow,
  Inline,
  Heading,
  Text,
} from 'braid-design-system';

import { InitialViewIconSvg } from '../../SVG';

import translations from './.vocab';

import * as styles from './SplitViewInitialView.css';

const InitialView = () => {
  const { t } = useTranslations(translations);
  return (
    <Box
      height="full"
      width="full"
      paddingX="xlarge"
      paddingY="xxlarge"
      data-automation="initialView"
      borderRadius="large"
      background="neutralSoft"
      position="absolute"
    >
      <Inline space="xxsmall">
        <IconArrow direction="left" />
        <Stack space="medium">
          <Heading level="3">{t('Select a job')}</Heading>
          <Text tone="secondary">{t('Display details here')}</Text>
        </Stack>
      </Inline>
      <Box className={styles.iconWrapper}>
        <InitialViewIconSvg />
      </Box>
    </Box>
  );
};
export default InitialView;
